import React from 'react';
import { HydratedSnippet } from '../../../api/signalSearchApi';
import { Snippet } from '../../../components/UI';
import HTMLTable from '../../../components/HTMLTable';
import styles from './HydratedSnippetView.module.scss';

interface Props {
  snippet: HydratedSnippet;
}

const HydratedSnippetView: React.FC<Props> = ({ snippet }) => {
  if (snippet.chunk_type === 'image' && /^https?:\/\//.test(snippet.blurb)) {
    return <img src={snippet.blurb} alt="Document" className={styles.image} />;
  }
  if (snippet.chunk_type === 'table') {
    return <HTMLTable html={snippet.blurb} />;
  }
  return <Snippet blurb={snippet.blurb} />;
};

export default HydratedSnippetView;
